import classNames from 'classnames';

const getColorClassName = (disabled?: boolean, selected?: boolean) => {
  if (disabled) {
    return 'text-status-disabled-dark';
  }
  if (selected) {
    return 'text-status-warning';
  }
  return 'text-shade-20';
};

export const getBookmarkClassNames = (
  className?: string,
  disabled?: boolean,
  selected?: boolean,
): string =>
  classNames(
    className,
    disabled && 'pointer-events-none',
    'p-2xs rounded',
    'focus-visible:outline-none focus-visible:ring',
    'hover:bg-state-hover active:bg-state-press',
    getColorClassName(disabled, selected),
  );
